import React from "react";
import PropTypes from "prop-types";
import {UserEventStatisticCard} from "./UserEventStatisticCard";

export class UserEventStatistics extends React.Component {
    constructor(props) {
        super(props);
        this.progressStyle = {
            height: "9px",
        };
        this.progressCardStyle = {
            backgroundColor: "#fff",
        };
    }

    getProgressBarStyle = occupancyPercentage => ({
        width: `${this.normalizePercentage(occupancyPercentage)}%`,
        backgroundColor: this.getProgressColor(occupancyPercentage),
    })

    normalizePercentage = occupancyPercentage => Math.max(0, Math.min(occupancyPercentage, 100))

    getProgressColor = occupancyPercentage => {
        const percentage = this.normalizePercentage(occupancyPercentage);
        const red = percentage < 50 ? 220 : Math.round(220 - ((percentage - 50) * 3.12));
        const green = percentage < 50 ? Math.round(53 + (percentage * 3.56)) : Math.round(193 - ((percentage - 50) * 0.8));
        return `rgb(${red}, ${green}, 69)`;
    }

    render() {
        const statistics = this.props.statistics || {};
        const reservations = statistics.reservations || {};
        const participants = statistics.participants || {};
        const occupancyPercentage = parseInt(participants.occupancy_percentage, 10) || 0;

        return (
            <div className={"mb-3"}>
                <h6 className={"font-weight-bold mb-2"}>Andamento evento</h6>

                {
                    participants.expected &&
                    <div className={"shadow-sm rounded p-2 mb-2"} style={this.progressCardStyle}>
                        <div className={"d-flex justify-content-between align-items-center small mb-1"}>
                            <span className={"text-muted"}>Riempimento evento</span>
                            <span className={"font-weight-bold"}>{occupancyPercentage}%</span>
                        </div>
                        <div className={"progress"} style={this.progressStyle}>
                            <div
                                className={"progress-bar"}
                                role={"progressbar"}
                                style={this.getProgressBarStyle(occupancyPercentage)}
                                aria-valuenow={occupancyPercentage}
                                aria-valuemin={"0"}
                                aria-valuemax={"100"}
                            />
                        </div>
                    </div>
                }

                <div className={"row mx-n1"}>
                    <UserEventStatisticCard
                        icon={"users"} title={"Partecipanti"}
                        value={participants.expected ? `${participants.total} / ${participants.expected}` : participants.total}
                        color={"#246bfe"} backgroundColor={"#e9f0ff"}
                    />
                    <UserEventStatisticCard
                        icon={"user-check"} title={"Confermati"}
                        value={participants.confirmed}
                        color={"#198754"} backgroundColor={"#e8f6ef"}
                    />
                    <UserEventStatisticCard
                        icon={"hourglass-half"} title={"In attesa"}
                        value={participants.pending}
                        color={"#b58100"} backgroundColor={"#fff5d6"}
                    />
                    <UserEventStatisticCard
                        icon={"chair"} title={"Posti rimasti"}
                        value={participants.remaining_capacity}
                        color={"#087990"} backgroundColor={"#e5f7fb"}
                    />
                    <UserEventStatisticCard
                        icon={"clipboard-list"} title={"Prenotazioni"}
                        value={reservations.total}
                        color={"#6f42c1"} backgroundColor={"#f0e9fb"}
                    />
                    <UserEventStatisticCard
                        icon={"sticky-note"} title={"Con note"}
                        value={reservations.with_notes}
                        color={"#c05a00"} backgroundColor={"#fff0e3"}
                    />
                    <UserEventStatisticCard
                        icon={"exclamation-triangle"} title={"Intolleranze"}
                        value={reservations.with_intolerances}
                        color={"#c83232"} backgroundColor={"#fde9e9"}
                    />
                    <UserEventStatisticCard
                        icon={"signature"} title={"Nomi raccolti"}
                        value={participants.names_collected}
                        color={"#198754"} backgroundColor={"#e8f6ef"}
                    />
                </div>
            </div>
        );
    }
}

UserEventStatistics.propTypes = {
    statistics: PropTypes.object,
};
